import { PlanActionTypes } from "../models/planActions";
import { ADD_AUDIO } from "../types";

export default (data: string): PlanActionTypes => ({
    type: ADD_AUDIO,
    payload: data,
});
